module.exports = __webpack_public_path__ + "static/AIIconSDNew-564dba29902d06899ec5859c65a6d6a0.png";